import { useEffect } from 'react';

/**
 * useVideowallMode
 *
 * Sets up the document root to correctly support videowall CSS sizing inside a
 * CSS-transform–scaled canvas.
 * @param {number} designWidth  Width of the design canvas in px (default 3840).
 * @param {number} designHeight Height of the design canvas in px (default 2160).
 */
const useVideowallMode = (designWidth = 3840, designHeight = 2160) => {
  useEffect(() => {
    const vwValue = designWidth / 100;   // e.g. 38.4 for 3840 px canvas
    const vhValue = designHeight / 100;  // e.g. 21.6 for 2160 px canvas

    document.documentElement.style.setProperty('--vw', `${vwValue}px`);
    document.documentElement.style.setProperty('--vh', `${vhValue}px`);
    document.documentElement.dataset.displayMode = 'videowall';

    return () => {
      document.documentElement.style.removeProperty('--vw');
      document.documentElement.style.removeProperty('--vh');
      delete document.documentElement.dataset.displayMode;
    };
  }, [designWidth, designHeight]);
};

export default useVideowallMode;
